import _sfc_main from "./AudioSettingTab.vue2.mjs";
/* empty css                      */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: ["audio-setting-tab", _setup.themeClass] }, [_c("div", { staticClass: "item-setting" }, [_c("span", { staticClass: "title" }, [_vm._v(_vm._s(_setup.t("Mic")))]), _c("div", { staticClass: "flex" }, [_c(_setup.DeviceSelect, { staticClass: "select", attrs: { "device-type": "microphone" } }), _setup.isDetailMode ? _c(_setup.TuiButton, { staticClass: "button", attrs: { "type": "primary" }, on: { "click": _setup.handleMicrophoneTest } }, [_vm._v(" " + _vm._s(_setup.isTestingMicrophone ? _setup.t("Stop") : _setup.t("Test")) + " ")]) : _vm._e()], 1)]), _c("div", { staticClass: "item-setting" }, [_c("span", { staticClass: "title" }, [_vm._v(_vm._s(_setup.t("Output")))]), _c("div", { staticClass: "mic-bar-container" }, _vm._l(new Array(_setup.volumeTotalNum).fill(""), function(item, index) {
    return _c("div", { key: index, class: [
      "mic-bar",
      `${_setup.showVolume && _setup.volumeNum > index ? "active" : ""}`
    ] });
  }), 0)]), _setup.speakerList.length > 0 ? _c("div", { staticClass: "item-setting" }, [_c("span", { staticClass: "title" }, [_vm._v(_vm._s(_setup.t("Speaker")))]), _c("div", { staticClass: "flex" }, [_c(_setup.DeviceSelect, { staticClass: "select", attrs: { "device-type": "speaker", "disabled": _vm.mode === _setup.SettingMode.DETAIL } }), _setup.isDetailMode ? _c(_setup.TuiButton, { staticClass: "button", attrs: { "type": "primary" }, on: { "click": _setup.handleSpeakerTest } }, [_vm._v(" " + _vm._s(_setup.isTestingSpeaker ? _setup.t("Stop") : _setup.t("Test")) + " ")]) : _vm._e()], 1)]) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "4e811209"
);
const AudioSettingTab = __component__.exports;
export {
  AudioSettingTab as default
};
